import  React from 'react';
import { HelpBox } from './help_box.jsx';

export const AreaInput = ({id, label, onInputChange, value, title, helpText, dividerTitle, maxLength = '256',
  placeHolder = "",
  mandatory = false}) => {
  
  let labelItem = (
      <label className="input-label">
        {label}{mandatory && <span className="mandatory-asterix"> *</span>}
      </label>
    );
  
  let inputItem;

    inputItem = (
      <AreaInputField
        id={id}
        onInputChange={ onInputChange }
        value={ value }
        maxLength={maxLength}
        placeHolder={placeHolder}
      />
    );

  return(
    <div id={id} className="select-dropdown">
      {dividerTitle && <div className="head">{dividerTitle}</div>}
      <div className="head">{title}</div>
      <div className={"general-text-area input-item "} id={id}>
        {inputItem}
        {labelItem}
      </div>
      <div className="area-help-box">
        { helpText ?
            <HelpBox data={[
              {
                text: helpText
              }
            ]}/> : null
          }
      </div>
    </div>
  );
};


const AreaInputField = ({id, onInputChange, value, maxLength, placeHolder}) => {

  return(
      <textarea
        className="input"
        type="text"
        onInput={ ({target} ) => onInputChange(target.value) }
        onChange={() => {}}
        value={ value }
        id={id + "Input"}
        placeholder={placeHolder ? placeHolder : ""}
        maxLength={maxLength}
      />
  );
};


